import axios from "axios";

export const useAuthApi = () => {
    return {
        async changePassword(token, idUser, userType, currentPassword, newPassword) {
            let data = {
                idUser, userType, currentPassword, newPassword
            };
            let response = await axios.post(`${process.env.REACT_APP_API_URL}/profile/change-password`, data, { 
                headers: {
                    Authorization: "Bearer " + token
                }
            });

            return response.data;
        },
        async changeEmail(token, idUser, userType, email) {
            let data = {
                idUser, userType, email
            };
            let response = await axios.post(`${process.env.REACT_APP_API_URL}/profile/confirm-email`, data, { 
                headers: {
                    Authorization: "Bearer " + token
                }
            });

            return response.data;
        },
        async newPassword(token, idUser, userType, newPassword) {
            let data = {
                idUser, userType, newPassword
            };
            let response = await axios.post(`${process.env.REACT_APP_API_URL}/profile/new-password`, data, { 
                headers: {
                    Authorization: "Bearer " + token
                }
            });

            return response.data;
        },
    }
}